export const breakpoints = {
  medium: 600,
  large: 1024,
};
